import { render, staticRenderFns } from "./AuditoriaMolexRadialBarChartRectificaciones.vue?vue&type=template&id=4c5af14f"
import script from "./AuditoriaMolexRadialBarChartRectificaciones.vue?vue&type=script&lang=js"
export * from "./AuditoriaMolexRadialBarChartRectificaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports